import React, { useState, useEffect } from 'react';
import Button from 'components/base/Button';
import { withTheme } from 'react-jsonschema-form';
import LayoutField from 'react-jsonschema-form-layout-2';
import Bootstrap4Theme from 'react-jsonschema-form-bs4';
import { Col, Row, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import LoadingOverlay from 'components/loading-overlay/LoadingOverlay';
import { createContainer, getLocations } from 'api/api';
import PageBreadcrumb from 'components/common/PageBreadcrumb';

const breadcrumbItems = [
  {
    label: 'Containers',
    url: '/containers/containers'
  },
  {
    label: 'Add',
    active: true
  }
];

function AddContainer() {
  const navigate = useNavigate();
  const Form = withTheme(Bootstrap4Theme);
  const [formData, setFormData] = useState();
  const [error, setError] = useState([]);
  const [loading, setLoading] = useState(false);
  const [locationName, setLocationName] = useState([]);
  const [locationIds, setLocationIds] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setError([]);
    setLoading(true);

    getLocations()
      .then(response => {
        const keys = response.data.data.data.map(g => g.id);
        const names = response.data.data.data.map(g => g.name);
        setLocationName(names);
        setLocationIds(keys);
      })
      .catch(err => {
        try {
          setError(err.response.data.errors);
        } catch (ex) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  const handleSubmit = ({ formData }) => {
    setError([]);
    setFormData(formData);
    setLoading(true);

    createContainer(formData)
      .then(response => {
        if (response.status === 200) navigate('/containers/containers');
      })
      .catch(err => {
        try {
          setError(err.response.data.errors);
        } catch (error) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  const schema = {
    type: 'object',
    required: ['name'],
    properties: {
      name: {
        title: 'Container Name',
        type: 'string'
      },
      location_id: {
        title: 'Location',
        type: 'number',
        enum: locationIds,
        enumNames: locationName
      }
    }
  };

  const uiSchema = {
    'ui:field': 'layout',
    name: {
      'ui:autofocus': true
    },
    'ui:layout': [{ name: { md: 8 } }, { location_id: { md: 8 } }]
  };

  const fields = {
    layout: LayoutField
  };

  return (
    <div>
      <PageBreadcrumb items={breadcrumbItems} />
      <div className="mb-9">
        <div className="d-flex flex-wrap gap-3 flex-between-end mb-5">
          <div>
            <h2 className="mb-2">Add a Container</h2>
            <h5 className="text-700 fw-semi-bold">Add a new container</h5>
          </div>
        </div>
        <Row className="g-5">
          <Col xs={12} xl={8}>
            <div>
              <div>
                {Object.entries(error).length > 0 &&
                  error.map((e, index) => (
                    <Alert variant="soft-danger" key={index}>
                      {e}
                    </Alert>
                  ))}
              </div>

              {loading && <LoadingOverlay />}

              <Form
                schema={schema}
                uiSchema={uiSchema}
                fields={fields}
                onSubmit={handleSubmit}
                formData={formData}
                showErrorList={false}
              >
                <div
                  className="d-flex flex-wrap gap-2"
                  style={{ marginTop: '10px' }}
                >
                  <Button variant="primary" type="submit">
                    Submit
                  </Button>
                  <Button
                    variant="phoenix-secondary"
                    type="button"
                    onClick={() => navigate('/containers/containers')}
                  >
                    Discard
                  </Button>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default AddContainer;
